(function () {
  const input = document.getElementById('polo-cep-input');
  const stateSelect = document.getElementById('polo-cep-state');
  const button = document.getElementById('polo-cep-button');
  const feedback = document.getElementById('polo-cep-feedback');
  const results = document.getElementById('polo-cep-results');

  if (!input || !stateSelect || !button || !feedback || !results) return;

  const root =
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

  function onlyDigits(value) {
    return (value || '').replace(/\D/g, '');
  }

  function formatCep(value) {
    const digits = onlyDigits(value).slice(0, 8);
    if (digits.length <= 5) return digits;
    return `${digits.slice(0, 5)}-${digits.slice(5)}`;
  }

  function setLoading(isLoading) {
    button.disabled = isLoading;
    button.textContent = isLoading ? 'Calculando...' : 'Calcular';
  }

  function setFeedback(message) {
    feedback.textContent = message || '';
  }

  function clearResults() {
    results.innerHTML = '';
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatMoney(value) {
    const raw = String(value ?? '').trim();

    if (raw === '') {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(0);
    }

    const numeric = Number(raw.replace(',', '.'));

    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(Number.isFinite(numeric) ? numeric : 0);
  }

  function getEtaText(rate) {
    if (Array.isArray(rate.delivery_days) && rate.delivery_days.length === 2) {
      const [min, max] = rate.delivery_days;
      if (min === max) return `${min} dia(s) úteis`;
      return `${min} a ${max} dias úteis`;
    }

    if (typeof rate.delivery_range === 'string' && rate.delivery_range.trim()) {
      return rate.delivery_range;
    }

    return 'Prazo informado no checkout';
  }

  function renderRates(data) {
    clearResults();

    const rates = data && Array.isArray(data.shipping_rates)
      ? data.shipping_rates
      : [];

    if (!rates.length) {
      setFeedback('Não encontramos opções de frete para este CEP no carrinho atual.');
      return;
    }

    setFeedback(`Encontramos ${rates.length} opção(ões) de frete.`);

    results.innerHTML = rates
      .map((rate) => {
        const name = rate.presentment_name || rate.name || 'Frete';
        const eta = getEtaText(rate);
        const price = formatMoney(rate.price);

        return `
          <div class="polo-cep-result-item">
            <div>
              <div class="polo-cep-result-name">${escapeHtml(name)}</div>
              <div class="polo-cep-result-meta">${escapeHtml(eta)}</div>
            </div>
            <div class="polo-cep-result-price">${escapeHtml(price)}</div>
          </div>
        `;
      })
      .join('');
  }

  async function getCart() {
    const response = await fetch(`${root}cart.js`, {
      method: 'GET',
      credentials: 'same-origin'
    });

    if (!response.ok) {
      throw new Error('Não foi possível consultar o carrinho atual.');
    }

    return response.json();
  }

  async function prepareShippingRates(cep, state) {
    const params = new URLSearchParams({
      'shipping_address[zip]': cep,
      'shipping_address[country]': 'Brazil',
      'shipping_address[province]': state
    });

    const response = await fetch(
      `${root}cart/prepare_shipping_rates.json?${params.toString()}`,
      {
        method: 'POST',
        credentials: 'same-origin'
      }
    );

    if (!response.ok && response.status !== 202) {
      const text = await response.text().catch(() => '');
      throw new Error(text || `Falha ao preparar frete (${response.status}).`);
    }
  }

  async function pollShippingRates(cep, state, maxAttempts = 8, intervalMs = 900) {
    const params = new URLSearchParams({
      'shipping_address[zip]': cep,
      'shipping_address[country]': 'Brazil',
      'shipping_address[province]': state
    });

    for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
      const response = await fetch(
        `${root}cart/async_shipping_rates.json?${params.toString()}`,
        {
          method: 'GET',
          credentials: 'same-origin'
        }
      );

      if (!response.ok) {
        const text = await response.text().catch(() => '');
        throw new Error(text || `Falha ao consultar frete (${response.status}).`);
      }

      const data = await response.json();

      if (data !== null) {
        return data;
      }

      await new Promise((resolve) => setTimeout(resolve, intervalMs));
    }

    throw new Error('O cálculo demorou mais que o esperado.');
  }

  async function fetchShippingRatesDirect(cep, state) {
    const params = new URLSearchParams({
      'shipping_address[zip]': cep,
      'shipping_address[country]': 'Brazil',
      'shipping_address[province]': state
    });

    const response = await fetch(
      `${root}cart/shipping_rates.json?${params.toString()}`,
      {
        method: 'GET',
        credentials: 'same-origin'
      }
    );

    if (!response.ok) {
      const text = await response.text().catch(() => '');
      throw new Error(text || `Falha no frete direto (${response.status}).`);
    }

    return response.json();
  }

  async function handleCalculate() {
    const cep = onlyDigits(input.value);
    const state = stateSelect.value;

    clearResults();

    if (cep.length !== 8) {
      setFeedback('Digite um CEP válido com 8 números.');
      return;
    }

    if (!state) {
      setFeedback('Selecione o estado para calcular o frete.');
      return;
    }

    try {
      setLoading(true);
      setFeedback('Calculando frete...');

      const cart = await getCart();

      if (!cart || !cart.item_count) {
        setFeedback('Adicione o produto ao carrinho para calcular o frete real.');
        return;
      }

      try {
        await prepareShippingRates(cep, state);
        const data = await pollShippingRates(cep, state);
        renderRates(data);
      } catch (asyncError) {
        console.warn('Fluxo async falhou, tentando fallback direto.', asyncError);
        const data = await fetchShippingRatesDirect(cep, state);
        renderRates(data);
      }
    } catch (error) {
      console.error('Erro no cálculo de frete:', error);
      setFeedback(`Erro ao calcular frete: ${error.message}`);
    } finally {
      setLoading(false);
    }
  }

  input.addEventListener('input', function () {
    input.value = formatCep(input.value);
  });

  input.addEventListener('keydown', function (event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleCalculate();
    }
  });

  button.addEventListener('click', handleCalculate);

  const couponInput = document.getElementById('polo-coupon-input');
  const couponButton = document.getElementById('polo-coupon-button');
  const couponFeedback = document.getElementById('polo-coupon-feedback');

  function setCouponLoading(isLoading) {
    if (!couponButton) return;
    couponButton.disabled = isLoading;
    couponButton.textContent = isLoading ? 'Aplicando...' : 'Aplicar';
  }

  function setCouponFeedback(message) {
    if (!couponFeedback) return;
    couponFeedback.textContent = message || '';
  }

  function applyCoupon() {
    if (!couponInput || !couponButton || !couponFeedback) return;

    const code = (couponInput.value || '').trim().toUpperCase();
    const allowedCoupons = ['BEMVINDO10'];

    if (!code) {
      setCouponFeedback('Digite um cupom para aplicar.');
      return;
    }

    if (code.length < 4) {
      setCouponFeedback('Digite um cupom válido.');
      return;
    }

    if (!allowedCoupons.includes(code)) {
      setCouponFeedback('Cupom inválido.');
      return;
    }

    couponInput.value = code;
    setCouponLoading(true);
    setCouponFeedback('Tentando aplicar o cupom...');

    const encodedCode = encodeURIComponent(code);
    const redirectTo = encodeURIComponent('/cart');

    window.location.href = `${root}discount/${encodedCode}?redirect=${redirectTo}`;
  }

  if (couponInput && couponButton && couponFeedback) {
    couponInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        applyCoupon();
      }
    });

    couponButton.addEventListener('click', applyCoupon);
  }
})();